import { createAction } from '@reduxjs/toolkit';
import type { AdminItemStatus } from '@/api/istaff/adminItems';
import { adminItemsSlice } from './slice';

export const loadAdminItems = createAction<
  | {
      page?: number;
      perPage?: number;
      status?: AdminItemStatus | 'all';
      // Background refreshes (polling, realtime events) shouldn't blank the
      // table with a loading spinner — only user-initiated loads should.
      silent?: boolean;
    }
  | undefined
>('adminItems/loadAdminItems');
export const syncOpenCount = createAction('adminItems/syncOpenCount');
export const resolveItem = createAction<string>('adminItems/resolveItem');
export const archiveItem = createAction<string>('adminItems/archiveItem');

export const {
  setLoading,
  setAdminItemsStatus,
  setAdminItemsPage,
  setOpenCount,
  removeItem,
} = adminItemsSlice.actions;
